<template>
	<section class="event-calendar" :class="{ 'event-calendar--thunderdome': brand === 'thunderdome' }">
		<div v-if="hasConfig" class="event-calendar__heading-wrapper">
			<h1 v-if="$te('page.home.title')" class="event-calendar__heading">
				{{ $t('page.home.title', { brand: brand.toUpperCase() }) }}
			</h1>
			<div v-if="$te('page.home.lead')" class="event-calendar__body" v-html="$t('page.home.lead')"></div>
		</div>

		<div v-else class="event-calendar__heading-wrapper">
			<p class="event-calendar__body">{{ $t('error.no_config_found') }}</p>
		</div>

		<Grid>
			<Column class="event-calendar__item" v-for="(item, index) in data" :key="index + item.slug">
				<EventCalendarItem
					:data="{
						slug: item.slug,
						...item.festivalData,
						eventDateTimeFormat: item.eventDatetimeFormat,
						membersale: item.membersale,
						travelsale: item.travelsale,
						preregistration: item.preregistration,
						queueUrl: item.queueUrl,
						url: !item.slug && item.url,
						isComingSoonItem: item.isComingSoonItem,
						comingSoonData: item.isComingSoonItem ? item : null,
						showEventEndsOn: item.showEventEndsOn ? item.showEventEndsOn : false,
						shopTheme: item.shopTheme
					}"
				/>
			</Column>
		</Grid>
	</section>
</template>

<script>
import EventCalendarItem from '@/components/home/EventCalendarItem';
import SetBasicShopData from '@/plugins/SetBasicShopData';
import FormatShopData from '@/plugins/FormatShopData';
import { createClient } from '@/plugins/ContentfulClient';
import SetMetaDataMixin from '@/mixins/SetMetaDataMixin';
import SetCssVars from '@/mixins/SetCssVars';
import preserveUTMParams from '@/utils/preserveUTMParams';

export default {
	name: 'PageIndex',

	components: {
		EventCalendarItem
	},

	mixins: [SetMetaDataMixin, SetCssVars],

	data() {
		return {};
	},

	async asyncData({ app, store, params, route, redirect }) {
		const client = createClient();
		const [config] = await Promise.all([
			client.getEntries({
				content_type: 'ossConfig',
				include: 4
			})
		]);

		if (config) {
			if (config.items.length) {
				// Set the general shop data
				const ossConfig = config.items[0].fields;
				SetBasicShopData(ossConfig, store);
				const allShops = FormatShopData(config);
				const activeShops = allShops.filter(item => item.saleActive === true);
				const activeShopsInOverview = activeShops.filter(item => item.shopVisibleInOverview === true);
				if (activeShopsInOverview.length === 1) {
					// If only one shop is set to show on the overviewpage redirect to this shop
					if (!activeShopsInOverview[0].url) {
						// Check if the only shop is internal or external
						const query = route.fullPath.split('?')[1];
						let uri = activeShopsInOverview[0].slug;
						if (query && query.length) {
							uri = `${activeShopsInOverview[0].slug}?${route.fullPath.split('?')[1]}`;
						}

						redirect(preserveUTMParams(`/${uri}`));
					}
				} else if (activeShops.length === 1) {
					// else if only one shop is active redirect to that shop
					// redirect(`/${activeShops[0].slug}`);
					// redirect('/');
				}

				return {
					data: activeShopsInOverview
				};
			}
		} else {
			store.commit('setHasConfig', false);
		}

		return {
			data: []
		};
	},

	computed: {
		hasConfig() {
			return this.$store.getters.getHasConfig;
		},
		brand() {
			return this.$store.getters.getBrand;
		}
	},

	methods: {},

	beforeCreate() {
		this.$store.commit('shopconfig/setResetShop');
		this.$store.commit('shopapi/setResetShop');
		this.$store.commit('setShowCounter', false);
	},

	mounted() {
		// Document isn't defined earlier than here
		this.setCssVars(true);
	}
};
</script>

<style lang="scss">
$component: 'event-calendar';

.#{$component} {
	display: block;

	color: $color-white;

	&__heading-wrapper {
		width: 100%;
		max-width: 680px;

		padding: 127px 0;
		margin: 0 auto;

		text-align: center;
	}

	&__heading {
		font-size: 48px;
	}

	&__body {
		display: block;
		padding-top: 10px;
		font-size: 20px;
	}

	&__item {
		margin-bottom: 40px;
	}

	@include sm {
		&--thunderdome {
			.event-calendar__heading-wrapper {
				padding: 60px 30px 60px;
			}

			.event-calendar__heading {
				margin-bottom: 20px;
			}
		}
		&__heading-wrapper {
			padding: 60px 0 60px;
		}

		&__heading {
			font-size: 22px;
		}

		&__body {
			font-size: 12px;
			padding-top: 0;
		}
	}
}
</style>
